import axios from "./axiosInstance";
import { AuditLog, AuditLogsApiResponse, AuditLogsResponse } from "../types/auditLogTypes";

/**
 * Get all audit logs with optional filters
 */
export const getAuditLogs = async (
  params: Record<string, any> = {}
): Promise<AuditLogsApiResponse> => {
  const response = await axios.get<AuditLogsApiResponse>("/audit-logs", {
    params,
  });
  return response.data;
};

/**
 * Get a specific audit log by ID
 */
export const getAuditLogById = async (id: string): Promise<AuditLog> => {
  const response = await axios.get<AuditLog>(`/audit-logs/${id}`);
  return response.data;
};
